import { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux'
import axios from "axios";
// List products with Api
export default function  ListControlByUser(offset, limit, path, path_type="", path_id=""){
    const isMounted = useRef(true);
    const [state, setState] = useState({ data: null, loading: true, error: null });
    const paths_type = (path_type)?'&'+path_type+'='+path_id : '';
    const user = useSelector( state => state.auth );
    let url = process.env.REACT_APP_ADMIN_API_URL + "/"+ path + "?offset="+offset+"&limit="+limit+paths_type+"&user_id="+user.id;
    useEffect( () => {
        return () => {
            isMounted.current = false;
        }
    }, [])
    const sendQuery = useCallback(async () => {
        
        let jwt = user.token;
        setState(null);
        let config = {
        method: 'get',
        url: url,
        headers: { 
            'Authorization': 'Bearer '+jwt, 
        }
        };
        axios(config)
        .then(function (response) {
        if ( isMounted.current ) {
            let data = response.data.data;
            setState({
                loading: false,
                error: null,
                data: data,
            });
        } 
       
        })
        .catch(function (error) {
            setState({
                loading: false,
                error: error,
                data: null,
            });
            //throw error;
            sessionStorage.removeItem('userSelect');
        });
    }, [url, user]);
    
    useEffect( () => {
        setState({ data: null, loading: true, error: null });
        sendQuery()
    },[]);

    return state;

};